import { render, staticRenderFns } from "./IconArrowUp.vue?vue&type=template&id=6c0379b8"
import script from "./IconArrowUp.vue?vue&type=script&lang=js"
export * from "./IconArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports